import { HowItWorksSection, WhySection, FaqSection, FinalCta } from "../../components/sections";
import { Reveal } from "../../components/Reveal";
import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Monitor, MessageSquare, CheckCircle2 } from "lucide-react";

export default function HowItWorks() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/content/faqs").then(({ data }) => setFaqs(data)); }, []);
  return (
    <>
      <section className="pt-36 pb-8 px-5 sm:px-8" data-testid="how-page">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">How It Works</span>
            <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-6xl text-brand-purpleDeep leading-tight">
              Making great video shouldn't be complicated.
            </h1>
            <p className="mt-5 text-lg text-brand-purpleDeep/60 max-w-2xl mx-auto">
              We don't just make your video. We make the whole process easy — you'll always know exactly where things are at.
            </p>
          </Reveal>
        </div>
      </section>
      <HowItWorksSection />

      {/* Portal highlight */}
      <section className="py-24 px-5 sm:px-8 bg-white">
        <div className="max-w-6xl mx-auto rounded-3xl bg-brand-light/60 border border-brand-purple/10 p-10 sm:p-14">
          <Reveal>
            <div className="max-w-2xl">
              <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">Your project, one place</span>
              <h2 className="mt-3 font-heading font-extrabold text-3xl sm:text-4xl text-brand-purpleDeep">
                Track everything from your own login.
              </h2>
              <p className="mt-4 text-brand-purpleDeep/60">
                Every EasyVideo client gets a private portal. Your draft video, comments, files and approvals all live together — no messy email threads.
              </p>
            </div>
          </Reveal>
          <div className="mt-10 grid gap-4 sm:grid-cols-3">
            {[
              { icon: Monitor, t: "See your progress", d: "Planning → Filming → Editing → Review → Complete, at a glance." },
              { icon: MessageSquare, t: "Talk to your team", d: "Message us right inside your project. No lost emails." },
              { icon: CheckCircle2, t: "Approve in one click", d: "Watch the cut, request changes or approve — done." },
            ].map((f, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="bg-white rounded-2xl p-6 border border-border h-full">
                  <div className="w-12 h-12 rounded-xl bg-brand-purple text-white flex items-center justify-center"><f.icon size={22} /></div>
                  <h3 className="mt-4 font-heading font-bold text-brand-purpleDeep">{f.t}</h3>
                  <p className="mt-1.5 text-sm text-brand-purpleDeep/60">{f.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <WhySection />
      <FaqSection faqs={faqs} />
      <FinalCta />
    </>
  );
}
